export class Address {
    public Address1: string = "";
    public Address2: string = "";
    public City: string = "";
    public State: string = "";
    public ZipCode: string = "";
    public IsSafeAtHomeAddress = false;
    public HasAcceptedSSAConsent: boolean = true;
}